var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":"primary","disabled":!_vm.canCreate,"to":_vm.to}},[_c('v-icon',[_vm._v(" mdi-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }